import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_go_to_checkout = _resolveComponent("go-to-checkout")

  return (_openBlock(), _createBlock(_component_go_to_checkout, { "continue-url": $options.checkoutUrl }, {
    default: _withCtx(({ onInvoke }) => [
      _createVNode(_component_tooltip, {
        enabled: !$options.canProceedToCheckout,
        text: $options.message,
        "data-qa": "mini-wizard-button:SubmitPledgeTooltip"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            theme: $options.submitPledgeButtonTheme,
            animation: $options.buttonAnimationType,
            display: "block",
            width: "narrow",
            tag: "a",
            href: $options.checkoutUrl,
            disabled: !$options.canProceedToCheckout,
            onClick: _withModifiers(onInvoke, ["stop","prevent"]),
            "data-qa": "mini-wizard-button:SubmitPledge"
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3 /* FORWARDED */
          }, 8 /* PROPS */, ["theme", "animation", "href", "disabled", "onClick"])
        ]),
        _: 2 /* DYNAMIC */
      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["enabled", "text"])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["continue-url"]))
}